import React, { FC, useRef, useState } from 'react';
import MainMenu from 'src/components/molecules/menu/MainMenu';
import GlobalMenu from 'src/components/molecules/menu/GlobalMenu';
import './style.scss';

interface Props {
  menu: any;
  clickEvt: (item: any) => void;
  styleDef?: React.CSSProperties;
}

const TabButton: FC<Props> = ({ menu, clickEvt, styleDef = {} }) => {
  const linkMenu = (e: React.MouseEvent, item: any) => {
    clickEvt(item);
  };
  return (
    <div className={['_tab_button_div_comp'].join(' ')}>
      {menu.map((item: any, idx: number) => {
        const active = item.active ? '_active' : '';
        return (
          <button
            style={styleDef}
            key={idx}
            className={['_button', active].join(' ')}
            onClick={e => linkMenu(e, item)}
          >
            <div className="_title">{item.title}</div>
          </button>
        );
      })}
    </div>
  );
};

export default TabButton;
